import PropTypes from "prop-types"
import React, { useEffect, useRef } from "react"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import { Link, withRouter } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"

const SidebarContent = props => {
  const ref = useRef()
  const authUser = JSON.parse(window.sessionStorage.getItem("authUser") || "{}")
  const perfil = authUser?.perfil
  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    const pathName = props.location.pathname

    const initMenu = () => {
      new MetisMenu("#side-menu")
      let matchingMenuItem = null
      const ul = document.getElementById("side-menu")
      const items = ul.getElementsByTagName("a")
      // Limpa estados anteriores
      ul.querySelectorAll("a.active").forEach(a => a.classList.remove("active"))
      ul.querySelectorAll(".mm-active").forEach(el => el.classList.remove("mm-active"))
      ul.querySelectorAll(".mm-show").forEach(el => el.classList.remove("mm-show"))
      for (let i = 0; i < items.length; ++i) {
        const anchor = items[i]
        // Ignora links que usam hash/to="#" (externos ou botões), pois o pathname coincide com a rota atual
        if (anchor.hash === "#" || anchor.getAttribute("to") === "#") {
          continue
        }
        if (pathName === anchor.pathname) {
          matchingMenuItem = anchor
          break
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem)
      }
    }
    initMenu()
  }, [props.location.pathname])

  useEffect(() => {
    ref.current.recalculate()
  })

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Analítico")} </li>
            {/* <li>
              <Link to="/dashboard-saas">
                <i className="bx bx-home-circle"></i>
                <span>{props.t("Dashboard")}</span>
              </Link>
            </li> */}

            <li>
              <Link to="/cockpit">
                <i className="bx bxs-dashboard"></i>
                {/* <span className="badge rounded-pill bg-danger float-end">
                  10
                </span> */}
                <span>{props.t("Cockpit")}</span>
              </Link>
            </li>

            <li className="menu-title">{props.t("Processamento")}</li>

            <li>
              <Link to="/qualificacao">
                <i className="bx bxs-eraser"></i>
                {/* to-do: contar pendentes */}
                {/* <span className="badge rounded-pill bg-danger float-end">
                  10
                </span> */}
                <span>{props.t("Qualificação")}</span>
              </Link>
            </li>

            <li>
              <Link to="/monitoramento">
                <i className="bx bxs-analyse"></i>
                {/* <span className="badge rounded-pill bg-danger float-end">
                  10
                </span> */}
                <span>{props.t("Monitoramento")}</span>
              </Link>
            </li>

            <li>
              <Link to="/empresas-monitoradas">
                <i className="bx bxs-business"></i>
                {/* <span className="badge rounded-pill bg-danger float-end">
                  10
                </span> */}
                <span>{props.t("Empresas Monitoradas")}</span>
              </Link>
            </li>

            <li className="menu-title">{props.t("Cadastros")}</li>

            <li>
              <Link to="/parceiros">
                <i className="bx bxs-buildings"></i>
                <span>{props.t("Parceiros")}</span>
              </Link>
            </li>

            {/* <li>
              <Link to="/seguradoras">
                <i className="bx bxs-shield"></i>
                <span>{props.t("Seguradoras")}</span>
              </Link>
            </li>

            <li>
              <Link to="/corretoras">
                <i className="bx bxs-briefcase"></i>
                <span>{props.t("Corretoras")}</span>
              </Link>
            </li> */}

            <li className="menu-title">Administração</li>
            {(perfil === "super_admin" || perfil === "admin") && (
              <li>
                <Link to="/contacts-list">
                  <i className="bx bx-user-circle"></i>
                  <span>{props.t("Usuários")}</span>
                </Link>
              </li>
            )}
            <li>
              <Link to="/resultados-publicacao-final">
                <i className="bx bxs-dashboard"></i>
                <span>{props.t("Publicação final")}</span>
              </Link>
            </li>
            <li>
              <Link to="/resultados-publicacao-geral">
                <i className="bx bxs-dashboard"></i>
                <span>{props.t("Publicação Geral")}</span>
              </Link>
            </li>
                        <li>
              <Link to="/painel-raspagem">
                <i className="bx bxs-dashboard"></i>
                <span>{props.t("Painel raspagem")}</span>
              </Link>
            </li>
            <li>
              <Link
                to="#"
                onClick={() => {
                  window.open("https://app.powerbi.com/links/FAMykdqyzg?ctid=6995b510-8386-4f54-b0c9-e9ca8f94a8aa&pbi_source=linkShare", "_blank")
                }}
              >
                <i className="bx bxs-dashboard"></i>
                <span>{props.t("Dashboard")}</span>
              </Link>
            </li>


            {/* <li className="menu-title">{props.t("Referencias")}</li>
            <li>
              <Link to="/apps-filemanager" >
                <i className="bx bx-file"></i>
                <span>{props.t("File Manager")}</span>
              </Link>
            </li>
            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-tone" />
                <span>{props.t("UI Elements")}</span>
              </Link>
              <ul className="sub-menu">
         
                <li>
                  <Link to="/ui-lightbox">{props.t("Lightbox")}</Link>
                </li>
                
                <li>
                  <Link to="/ui-toasts">{props.t("Toasts")}</Link>
                </li>
              
                <li>
                  <Link to="/ui-utilities">
                    <span className="badge rounded-pill bg-success float-end">
                      {props.t("New")}
                    </span>
                    {props.t("Utilities")}
                  </Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to="/#" className="has-arrow ">
                <i className="bx bx-list-ul"></i>
                <span>{props.t("Tables")}</span>
              </Link>
              <ul className="sub-menu">
       
                <li>
                  <Link to="/tables-datatable">{props.t("Data Tables")}</Link>
                </li>
                <li>
                  <Link to="/tables-responsive">
                    {props.t("Responsive Table")}
                  </Link>
                </li>
                <li>
                  <Link to="/tables-editable">{props.t("Editable Table")}</Link>
                </li>   
                
              </ul>
            </li>
            <li>
              <Link to="/#" >
                <i className="bx bxs-eraser"></i>
                <span className="badge rounded-pill bg-danger float-end">
                  10
                </span>
                <span>{props.t("Forms")}</span>
              </Link>
              <ul className="sub-menu">
               
                <li>
                  <Link to="/form-uploads">{props.t("Form File Upload")} </Link>
                </li>
               
                <li>
                  <Link to="/form-wizard">{props.t("Form Wizard")}</Link>
                </li>
               
              </ul>
            </li> */}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
